import { INavigationTheme } from 'styles/theme/navigation';

export enum PageLayoutActions {
  setIsHeaderVisible = 'setIsHeaderVisible',
  setIsFooterVisible = 'setIsFooterVisible',
  setIsMenuVisible = 'setIsMenuVisible',
  setToggleCurrentTheme = 'setToggleCurrentTheme',
  setMultipleLayoutOptions = 'setMultipleLayoutOptions',
}

export type MultipleLayoutOptions = {
  [key in PageLayoutActions]?: boolean;
};

export interface IPageLayoutAction {
  type: PageLayoutActions;
  payload: boolean | MultipleLayoutOptions;
}

export interface IPageLayoutToggleThemeAction {
  type: PageLayoutActions;
  payload: INavigationTheme;
}

type PageLayoutAction =
  | { type: PageLayoutActions.setIsHeaderVisible; payload: boolean }
  | { type: PageLayoutActions.setIsFooterVisible; payload: boolean }
  | { type: PageLayoutActions.setIsMenuVisible; payload: boolean }
  | { type: PageLayoutActions.setToggleCurrentTheme; payload: INavigationTheme }
  | { type: PageLayoutActions.setMultipleLayoutOptions; payload: MultipleLayoutOptions };

export type IPageLayoutDispatch = (action: PageLayoutAction) => void;

export interface IPageLayoutState {
  isHeaderVisible: boolean;
  isFooterVisible: boolean;
  isMenuVisible: boolean;
  isInApp: boolean;
  currentTheme: INavigationTheme | null;
}

export const pageLayoutReducer = (state: IPageLayoutState, action: PageLayoutAction) => {
  switch (action.type) {
    case PageLayoutActions.setIsHeaderVisible:
      state.isHeaderVisible = action.payload;
      break;
    case PageLayoutActions.setIsFooterVisible:
      state.isFooterVisible = action.payload;
      break;
    case PageLayoutActions.setIsMenuVisible:
      state.isMenuVisible = action.payload;
      break;
    case PageLayoutActions.setToggleCurrentTheme:
      state.currentTheme = action.payload;
      break;
    case PageLayoutActions.setMultipleLayoutOptions:
      {
        const actionToStateMap = {
          [PageLayoutActions.setIsHeaderVisible]: 'isHeaderVisible',
          [PageLayoutActions.setIsFooterVisible]: 'isFooterVisible',
          [PageLayoutActions.setIsMenuVisible]: 'isMenuVisible',
          [PageLayoutActions.setToggleCurrentTheme]: 'currentTheme',
        };
        for (const key of Object.keys(action.payload)) {
          const stateKey = actionToStateMap[key];
          state[stateKey] = action.payload[key];
        }
      }
      break;
    default:
      return state;
  }
  return state;
};
